/* eslint-disable react/jsx-no-bind */
/* eslint-disable camelcase */
import { Grid, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  AirDevice,
  DeviceCollectionSearchOutItem,
  LOGIC_CARD_VISIBILITY,
  OPERATORS,
  ProDevice,
  Trigger,
} from '@smartlife-redux-state/common';
import {
  select_dc,
  update_trigger,
} from '../../../../../../../store/redux/features/logic-engine/slice';
import { RootState } from '../../../../../../../store/redux/store';
import { ExpressionSelector } from '../shared/ExpressionSelector';
import { LocationSelector } from '../shared/LocationSelector';

const useStyles = makeStyles({
  formControl: {
    width: '100%',
  },
});

const LocationVariableTriggerForm: React.FC<{trigger: Trigger}> = ({ trigger }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const locaction_container = useSelector(
    (state: RootState) => state.rule_engine.location_variable_container,
  );

  function onLocationVaribleContainer(dc: DeviceCollectionSearchOutItem) {
    dispatch(
      select_dc({
        dc: { ...dc, has_verification_error: null },
        trigger_id: trigger.id,
      }),
    );
  }

  function onLocationVariable(device: ProDevice | AirDevice) {
    console.log('VARIABLE', device);
    try {
      const settings = !device ? null : JSON.parse(device.settings);
      const var_type = settings && settings.item_type;

      let type = null;
      switch (var_type) {
        case 'numeric_variable':
          type = 'Number';
          break;
        case 'string_variable':
          type = 'String';
          break;
        case 'boolean_variable':
          type = 'Boolean';
          break;
        case null:
          break;
        default:
          throw new Error('Variable type not supported');
      }

      dispatch(
        update_trigger({
          trigger: {
            ...trigger,
            device: device ? {
              ...device,
              has_verification_error: null,
            } : null,
            // since the location varibles only have numeric values, and state
            // set it when selecting the varible. No need to use <ExpressionVaribaleSelector />
            possible_variable_type: type,
            variable: !device ? null : 'state',
            condition: null,
            meta: {
              ...trigger.meta,
              is_enabled: true,
              card_visibility: LOGIC_CARD_VISIBILITY.ACTIVE,
            },
          },
        }),
      );
    } catch (err: any) {
      enqueueSnackbar(err.message, { variant: 'error' });
    }
  }

  function onExpressionChange(op: OPERATORS, value: any, variable: {field: string; type: string}) {
    console.log('on expresion selected', op, value, variable);
    dispatch(
      update_trigger({
        trigger: {
          ...trigger,
          op,
          condition: value,
          variable: variable.field,
          possible_variable_type: variable.type,
        },
      }),
    );
  }
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        <LocationSelector
          selectedVariable={trigger ? trigger.device : null}
          onLocVaribaleSelect={onLocationVariable}
          onLocationContSelect={onLocationVaribleContainer}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <ExpressionSelector
          selectedOperator={trigger ? trigger.op : OPERATORS.EQUAL}
          selectedVariable={{
            field: trigger.variable,
            type: trigger.possible_variable_type,
          }}
          selecteValue={trigger.condition}
          onChange={onExpressionChange}
          device={trigger.device}
          dc={locaction_container}
        />
      </Grid>
    </Grid>
  );
};

// eslint-disable-next-line import/prefer-default-export
export const LocationVariableTrigger: React.FC<{trigger: Trigger}> = ({ trigger }) => {
  const classes = useStyles();
  const [dcs, setDcs] = useState<any[]>([]);
  const [devices, setDevices] = useState<any[]>([]);

  return (
    <Box>
      <LocationVariableTriggerForm trigger={trigger} />
    </Box>
  );
};
